<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header">
				<div class="content">
					<el-row type="flex" justify="space-around" align="middle" style="height: 90px;">
						<el-col :span="10"  style="display: flex;align-items: center;flex-direction: row;">
							<div style="display: flex;align-items: center;margin-right: 10px;"><el-image style="width: 70px; height: 70px" :src="require('../../static/logo.png')" fit="scale-down"></el-image></div>
							<div >
								<div class="mediue-font">襄阳人才双创大数据平台</div>
							</div>
						</el-col>
						<el-col :span="8">

						</el-col>
						<el-col :span="6" >
							<el-row type="flex" justify="end">
								<el-button type="primary" size="medium" @click="goIndex()">返回首页</el-button>
							</el-row>
						</el-col>
					</el-row>
				</div>
			</el-header>
			<el-main>
				<div style="display: flex;text-align: center;flex-direction: column;width: 500px;margin: 100px auto 0px;background: #fff;padding: 50px 50px 50px 50px;">
					<el-radio-group v-model="radio1" style="text-align: center;margin-bottom: 20px;">
						  <el-radio-button :label="0">账号密码登录</el-radio-button>
						  <el-radio-button  :label="1"  @click="toWxAuthorization()">微信授权登录</el-radio-button>
					</el-radio-group>

					<template v-if="radio1 == 0">
						<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
						  <el-form-item label="手机号码" prop="telephone">
							<el-input type="telephone" v-model="ruleForm.telephone" autocomplete="off"></el-input>
						  </el-form-item>
						  <el-form-item label="密码" prop="password">
							<el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
						  </el-form-item>
						  <div style="text-align: center;">
							<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
						  </div>
						</el-form>
					</template>
					<template v-else><!-- http://online.fonery.cn/sovo -->
						<wxlogin  :appid="'wx8683c33354eeddb1'" :scope="'snsapi_login'"  :redirect_uri="'https://xyqyfw.com/sovo'" ></wxlogin>
					</template>
				</div>
			</el-main>
			<el-footer class="footer">
				<s-footer></s-footer>
			</el-footer>
			<el-footer class="copy-right">
				<s-copyRight></s-copyRight>
			</el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sFooter from '@/components/footer'
import sCopyRight from '@/components/copy-right'
import { login,getUserInfo } from '@/api'
import axios from 'axios';
import store from '@/store/index.js';
import wxlogin from 'vue-wxlogin'
export default {
	name: 'login',
	components:{
		sFooter,
		sCopyRight,
		wxlogin,
	},
	data () {
		var validateTel = (rule, value, callback) => {
			if (!value) {
			  return callback(new Error('手机号不能为空'));
			} else  if (!/^1(3|4|5|6|7|8)\d{9}$/.test(value)) {
				return callback(new Error('请输入正确的手机号'));
			} else {
				callback();
			}
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请输入密码'));
			} else {
			  if (this.ruleForm.checkPass !== '') {
				this.$refs.ruleForm.validateField('checkPass');
			  }
			  callback();
			}
		};
		return {
			radio1: '1',
			ruleForm:{
				telephone: '18310363531',
				password: '123456'
			},
			rules: {
				telephone: [
					{ validator: validateTel, trigger: 'blur' }
				],
				password: [
					{ validator: validatePass, trigger: 'blur' }
				]
			},
			url:''
		}
	},
	methods: {
		toWxAuthorization(){
			window.Location.href ="https://open.weixin.qq.com/connect/qrconnect?appid=wx8683c33354eeddb1&redirect_uri=http://online.fonery.cn/sovo&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect"
		},
		submitForm(formName) {
			let that = this
			that.$refs[formName].validate((valid) => {
			  if (valid) {
				login({
					telephone: that.ruleForm.telephone,
					password: that.ruleForm.password
				}).then(res=> {
					sessionStorage.setItem('token',res.data.token);
					localStorage.setItem('token',res.data.token);
					localStorage.setItem('login',true);
					store.commit('changeIsLogin', true);

					getUserInfo().then(res=> {
						//localStorage.setItem('userInfo',JSON.stringify(res.data))
						store.commit('changeUserInfo', res.data);
					})

					that.goIndex()
				})
			  } else {
				return false;
			  }
			});
		},
		goIndex(){
			this.$router.push({path:'/index'})
		}
	}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/login.vue